module.exports = __webpack_public_path__ + "img/impulse_thumbnail.21359db1.jpg";